<template>
  <div id="cat">
    <div class="vx-card">
      <div class="vx-card__body card-body">
        <div class="vx-row">
          <div class="vx-col w-full mb-base">
            <data-grid
              ref="grid"
              stripe
              :data-source="gridDataSource"
              :search-data="gridSearchData"
              :columns="[
                { title: $t('Description'), sort: 'Description' },
                { title: $t('VoucherCode'), sort: 'VoucherCode' },
                { title: $t('CreateOn'), sort: 'CreateOn' },
                { title: $t('Action'), sort: 'Action' },
              ]"
            >
              <template slot-scope="{ row }">
                <td style="width: 30%">
                  {{ row.description ? row.description : "-" }}
                </td>
                <td>{{ row.id }}</td>
                <td>{{ row.createOn }}</td>
                <td class="flex items-center justify-center">
                  <router-link
                    :to="{
                      path: '/CreditManagement/Voucher/Article/' + row.id,
                      query: {
                        breadcrumbNameManual: {
                          persianTitleParent: row.description,
                        },
                      },
                    }"
                  >
                    <vs-button
                      v-has-permission="'GetAllArticles'"
                      color="success"
                      size="small"
                      type="gradient"
                      icon-pack="feather"
                      icon="icon-eye"
                      class="gap-2"
                      >آرتیکل ها</vs-button
                    >
                  </router-link>
                </td>
              </template>
            </data-grid>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import "@/assets/scss/vuesax-rtl/pages/_custom.scss";
import DataGrid from "@/components/datagrid/DataGrid";

import moment from "moment";
export default {
  components: {
    DataGrid,
  },
  data() {
    return {
      gridDataSource: {
        type: "app",
        service: "/Credits/api/VouchersQuery",
      },
      gridSearchData: {
        keyword: "",
      },
    };
  },

  methods: {},
};
</script>
